import React from 'react';
import { Icon, sanitize, ButtonAction } from '@honeycomb-npm/honeycomb-react';
import { useSelector } from 'react-redux';
import { State } from '../../redux';
import { content } from '../../utils/contentUtils';

const ErrorPage = () => {
  const { error, callToAction, emailContent } = content;

  const { isEmailPreference } = useSelector((state: State) => state.mainReducer);

  const errorContent = isEmailPreference ? emailContent : error;

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="row">
      <div className="col-lg-8 col-sm-12">
        <h2>{errorContent.errorTitle}</h2>
        <div>
          <Icon
            screenreader="Error Icon"
            symbol="messageAlert32"
            type="svgfile"
          >
            <div dangerouslySetInnerHTML={sanitize(errorContent.errorMessage)} />
          </Icon>
        </div>
        <div className="mt-2" dangerouslySetInnerHTML={sanitize(errorContent.errorDesc)} />
        {isEmailPreference && (
          <div className="my-4">
            <ButtonAction onClick={handleReload}>
              {callToAction.tryagainBtn.displayText}
            </ButtonAction>
          </div>
        )}
        <div className="mt-2" dangerouslySetInnerHTML={sanitize(errorContent.errorMessageDisclaimer)} />
      </div>
    </div>
  );
};

export default ErrorPage;
